<template>
<v-card tile :flat='flat' class='dayview elevation-0' id='day'>
  <!-- <pre>{{markedUpEvents}}</pre>
  <div style='position:fixed;left:10px;bottom:10px;background:black;color:white;z-index:1000' >
    <v-chip class="secondary white--text">{{activePixels}}</v-chip>
    <v-chip class="secondary white--text">{{dragTime}}</v-chip>
  </div> -->
  <!-- p2m:{{pixelToMinuteRatio}} -->
  <div
    :style="{ height: periodInMins + 'px' }"
    class='period' >
    {{startHour}}
  </div>
  <div
    v-for='period in numPeriods'
    :key='period'
    :style="{ height: periodHeight + 'px' }"
    @click='newEvent(period)'
    class='period' >
    {{timeOfDay(startHour, period, periodInMins)}}
  </div>
  <!-- {{previewEvent}} -->
  <slot name='event' v-for='(event, index) in markedUpEvents' >
    <!-- <pre v-text='event' /> -->
    <day-event
      :key='`${event.id}-${index}`'
      v-model='markedUpEvents[index]'
      :selected-event='selectedEvent'
      :start-hour='startHour'
      :pixel-to-minute-ratio='pixelToMinuteRatio'
      :default-new-event-length='defaultNewEventLength'
      @click.exact='eventClicked'
      v-on='$listeners' />

      <!--
        :pixel-to-minute-ratio='pixelToMinuteRatio'
        :default-new-event-length='defaultNewEventLength'
        :max-width-percentage='maxWidthPercentage'
      -->
      <!-- @dayview:multiselect.stop='$emit("dayview:multiselect")'
      @click.exact='eventClicked' -->
  </slot>
  <div
    v-if='previewEventStyle && !previewEvent.id'
    class='event transient-event'
    :style='previewEventStyle' >
    {{previewEvent.start_time}} - {{previewEvent.end_time}}. {{ previewEventTitle }}
  </div>

  <appointment-bottom-sheet
    v-model='bottomsheet'
    :appointment='selectedEvent'
    :readOnly='readOnly' >
  </appointment-bottom-sheet>

</v-card>
</template>
<script type="text/javascript">
import moment from 'moment'
import AppointmentBottomSheet from '@/components/appointment/actions/AppointmentBottomSheet.vue'
import DayEvent from './DayEvent.vue'
// import interact from 'interact.js'

export default {
  moment,
  // interact,
  name: 'DayView',
  components: {AppointmentBottomSheet, DayEvent},
  props: {
    // display configurations:
    eventOffset: { type: Number, default: 5 },
    startHour: { type: Number, default: 5 },
    endHour: { type: Number, default: 20 },
    periodInMins: { type: Number, default: 15 },
    defaultNewEventLength: { type: Number, default: 30 },
    pixelToMinuteRatio: { type: Number, default: 1 },
    maxWidthPercentage: { type: Number, default: 90 },
    flat: { type: Boolean, default: false },
    readOnly: { type: Boolean, default: false },
    // datas
    date: { type: String, default: moment().format('YYYY-MM-DD') },
    events: { type: Array, default: () => { return [] } },
    selectedAppointment: { type: Object, required: false },
    previewEvent: { type: Object, required: false }
  },
  data () {
    return {
      bottomsheet: false,
      dragging: false,
      selectedEvent: {},
      activeTime: 0,
      activePixels: 0,
      activeEvent: {},
      eventClickWatcher: Math.random()
    }
  },
  computed: {
    numPeriods () {
      return (this.endHour * 60 - this.startHour * 60) / this.periodInMins
    },
    selectedEventId () {
      if (this.selectedEvent) {
        return this.selectedEvent.id
      }
    },
    periodsPerHour () {
      return 60 / this.periodInMins
    },
    periodHeight () {
      return (this.periodInMins * this.pixelToMinuteRatio)
    },
    dragTime () {
      let mins = this.activePixels
      let startTime = this.timeStringToMoment(this.activeEvent.start)
      return startTime.add(mins, 'minutes').format('HH:mm')
    },
    previewEventTitle () {
      if (this.previewEvent) {
        if (this.previewEvent.is_custom && this.previewEvent.title) { return this.previewEvent.title }

        if (this.previewEvent.client && this.previewEvent.client.first_name) {
          let title = this.previewEvent.client.first_name
          if (this.previewEvent.client.last_name) {
            title = title + ' ' + this.previewEvent.client.last_name
          }
          return title
        }
      }
      return null
    },
    previewEventStyle () {
      if (this.previewEvent && this.previewEvent.start_time && this.previewEvent.end_time && (this.previewEvent.end_time > this.previewEvent.start_time)) {
        let evt = JSON.parse(JSON.stringify(this.previewEvent)) // make a copy
        evt.start = evt.start_time
        evt.end = evt.end_time
        let style = this.getStyle(evt)
        return style
      }
      return null
    },
    markedUpEvents () {
      let index = 0
      let vm = this
      let events = []
      events = this.events.filter((evt) => {
        if (!evt.id) { return false }
        // no need for fancy filtering if it's a readonly
        if (this.readOnly === true) { return true }
        let freshEvt = this.$store.getters.getAppointment(evt.id)
        let existsToday = (freshEvt.dt === this.date)
        let existsForPractitioner = (freshEvt.practitioner === evt.practitioner)

        if (!existsForPractitioner) {
          let options = {id: evt.id, practitionerId: evt.practitioner, dt: this.date}
          this.$store.commit('cleanAppointment', options)
        }
        if (!existsToday) {
          let options = {id: evt.id, practitionerId: evt.practitioner, dt: this.date}
          this.$store.commit('cleanAppointment', options)
        }
        return (existsToday && existsForPractitioner)
      })
      events = events.sort((a, b) => {
        if (vm.timeStringToMoment(a.start)
                .isBefore(vm.timeStringToMoment(b.start))) {
          return -1
        }
        return 1
      })
      while (index <= events.length) {
        let event = events[index]
        let exactOverlaps = this.getExactOverlaps(
                              events,
                              event,
                              index)
        let overlapIndex = 0
        // todo: use Array.map
        while (overlapIndex <= exactOverlaps.length + 1) {
          let overlapevent = events[index + overlapIndex]
          if (overlapevent) {
            overlapevent.exactOverlapSequence = overlapIndex
            overlapevent.exactOverlapCount = exactOverlaps.length
          }
          overlapIndex++
        }
        if (index > 0) {
          let previousEvent = events[index - 1]
          if (this.hasPartialOverlap(event, previousEvent)) {
            let overlapCount = previousEvent.partialOverlapCount || 0
            event.hasPartialOverlap = true
            event.partialOverlapCount = overlapCount + 1
          }
        }
        index += Math.max(1, exactOverlaps.length)
      }
      // for (let event of events) {
      //   if (event) {
      //     Vue.set(event, 'styles', this.getStyle(event))
      //     event.dayStartHour = watchstring
      //   }
      // }
      return events
    }
  },
  watch: {
    selectedAppointment () {
      if (this.selectedAppointment) {
        this.bottomsheet = true
        this.selectedEvent = this.selectedAppointment
      }
    }
  },
  methods: {
    eventClicked (event) {
      this.globalSelectedAppointments = []

      this.selectedEvent = event
      this.$emit('dayview:eventclicked', event)
      this.bottomsheet = false
      let vm = this
      setTimeout(() => { vm.bottomsheet = true }, 100)
      return false
    },
    newEvent (period) {
      let dayStartMoment = this.timeStringToMoment(`${this.startHour}:00`)
      let minsFromStart = (period * this.periodInMins)
      let startMoment = dayStartMoment.add(minsFromStart, 'minutes')
      let endMoment = moment(startMoment)
                        .add(this.defaultNewEventLength, 'minutes')
      let data = {
        start_time: startMoment,
        end_time: endMoment,
        start: startMoment.format('HH:mm'),
        end: endMoment.format('HH:mm')
      }
      this.$emit('dayview:createevent', data)
    },
    // , height:eventDurationInPixels(event)
    timeToPixels (fromTimeString, toTimeString) {
      let startMoment = this.timeStringToMoment(fromTimeString)
      let toMoment = this.timeStringToMoment(toTimeString)
      let duration = moment.duration(toMoment.diff(startMoment))
      // 1x minute = 1 pixel
      // if (fromTimeString === '05:00') {
      //   console.log(fromTimeString, toTimeString, duration.asMinutes())
      // }
      let height = duration.asMinutes()
      if (this.pixelToMinuteRatio > 1) {
        height = height * this.pixelToMinuteRatio
      }
      // if (this.pixelToMinuteRatio > 0) {
      //   height = height - (this.periodHeight * this.pixelToMinuteRatio)
      // }
      return height
    },
    timeOfDay (start, period, interval) {
      let startMins = (start * 60)
      let timeFromStart = (period * interval)
      let totalMins = (startMins + timeFromStart)
      if (!(totalMins % 60)) {
        return totalMins / 60
      }
    },
    getStyle (event) {
      let top = this.timeToPixels(`0${this.startHour}` + ':00', event.start)
      if (this.pixelToMinuteRatio > 1) {
        top = top - (this.periodHeight / this.pixelToMinuteRatio)
      }
      // console.log('timeToPixels', event.start, event.end)
      // if (top === 0) { debugger }
      let styles = {
        top: top + 'px',
        height: this.timeToPixels(event.start, event.end) + 'px'
      }
      if (event.partialOverlapCount > 0) {
        let offset = (event.partialOverlapCount * this.eventOffset)
        let width = this.maxWidthPercentage - offset
        styles['left'] = offset + '%'
        styles['width'] = width + '%'
      }
      if (event.exactOverlapCount > 1) {
        let unitPercent = this.maxWidthPercentage / event.exactOverlapCount
        styles['left'] = (event.exactOverlapSequence * unitPercent) + '%'
        styles['width'] = unitPercent + '%'
      }
      /* if (event.selected) {
        styles['z-index'] = 1
      } else {
        styles['z-index'] = 0
      } */

      // remove transformations
      let target = document.getElementById('event-' + event.id)
      if (target) {
        // target.style.webkitTransform =
        target.style.transform = 'translate(0px, 0px)'
        // clear the position attributes
        target.setAttribute('data-x', 0)
        target.setAttribute('data-y', 0)
      }

      return styles
    },
    hasPartialOverlap (currentEvent, previousEvent) {
      if (currentEvent && previousEvent) {
        let previousEnd = this.timeStringToMoment(previousEvent.end)
        let currentStart = this.timeStringToMoment(currentEvent.start)
        return currentStart.isBefore(previousEnd, 'minute')
      }
      return false
    },
    getExactOverlaps (events, event, index, overlaps = []) {
      if (events.length === 0) { return [] }
      overlaps.push(event)
      if (index < events.length) {
        let nextEvent = events[index + 1]
        if (nextEvent && event) {
          let exactOverlap = (
            event.start === nextEvent.start &&
            event.end === nextEvent.end
          )
          if (exactOverlap) {
            this.getExactOverlaps(events, nextEvent, index + 1, overlaps)
          } else {
            return overlaps
          }
        }
      }
      return overlaps
    }
  }
}
</script>
<style scoped>
.dayview {
  position:relative;
  padding-left:5px;
}
.period {
  border-bottom: solid 1px #f1f1f1;
}
.event {
  position: absolute;
  border: solid 1px #ccc;
  background-color: rgb(58, 135, 173);
  color: white;
  font-size: smaller;
  width: 80%;
  margin-left:25px;
}
.event.transient-event {
  border: dashed 3px #ddd;
  background-color: #fffcfc;
  color: black;
  opacity: 0.7;
  width: 80%;
}
.event.status-p {
  color: #000;
}
.triangle {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 15px 15px 0;
  border-color: transparent #608A32 transparent transparent;
  right: 0;
  top: 0;
  position: absolute;
}

</style>



// WEBPACK FOOTER //
// DayView.vue?9626ae56